import { create } from 'zustand'
import * as ComplianceAPI from '../../../API/ComplianceAPI'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    // complianceCalendar
    complianceCalendarDetails: {},
    complianceCalendarLoading: false,
    complianceCalendarError: '',

    complianceOverDueDetails: [],
    complianceOverDueLoading: false,
    complianceOverDueError: '',

    // Due Today Compliances
    dueTodayCompliances: [],
    dueTodayLoading: false,
    showDueTodayPopup: false
}

const ComplianceContainerStore = (set) => ({
    ...initialState,

    CreateComplianceCalendar: async (complianceCalendarData) => {
        set({ complianceCalendarLoading: true })
        try {
            const response = await ComplianceAPI.CreateComplianceCalendar(complianceCalendarData)
            if (response.data) {
                set({ complianceCalendarLoading: false, complianceCalendarDetails: response.data })
            } else {
                set({ complianceCalendarLoading: false, complianceCalendarError: 'compliance details not found' })
            }
        } catch (err) {
            // set({ complianceCalendarLoading: false, complianceCalendarError: err.message || 'An error occurred' })
        }
    },

    CreateComplianceCalendarOverDue: async (complianceCalendarOverDueData) => {
        set({ complianceOverDueLoading: true })
        try {
            const response = await ComplianceAPI.CreateComplianceCalendarOverDue(complianceCalendarOverDueData)
            if (response.data) {
                set({ complianceOverDueLoading: false, complianceOverDueDetails: response.data })
            } else {
                set({ complianceOverDueLoading: false, complianceOverDueError: 'compliance ovderdue details not found' })
            }
        } catch (err) {
            // set({ complianceOverDueLoading: false, complianceOverDueError: err.message || 'An error occurred' })
        }
    },

    GetDueTodayCompliances: async (orgId, userId) => {
        set({ dueTodayLoading: true })
        try {
            const response = await ComplianceAPI.GetDueTodayCompliances(orgId, userId)
            if (response.data && response.data.length > 0) {
                set({
                    dueTodayLoading: false,
                    dueTodayCompliances: response.data,
                    showDueTodayPopup: true
                })
            } else {
                set({ dueTodayLoading: false, dueTodayCompliances: [], showDueTodayPopup: false })
            }
        } catch (err) {
            set({ dueTodayLoading: false, dueTodayCompliances: [], showDueTodayPopup: false })
        }
    },

    closeDueTodayPopup: () => {
        set({ showDueTodayPopup: false })
    }
})

export const useComplianceStore = create(devtools(immer(ComplianceContainerStore)))

